import { Injectable } from '@tanbo/vue-di-plugin'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'
import { parseIsNotEmptyObj } from '@/utils/tool'

export interface VirusDatabaseInfo {
   /** source_type 病毒库来源 默认值：file5 */
   source_type?: string
}

export interface VirusDatabaseInfoData {
  version: string
  window_virus_version: string
  app_key?: string
  /** 循环类型：1-每天；2-每3天；3-每周；4-每月 */
  frequency?: number
  /** 最近更新时间 */
  last_update_time?: string
  secret?: string
  /** 开始时间 */
  start_minutes?: string[] | string
  /** 定时更新状态 1=启动，2=禁用 */
  timing_update_status?: number
}


export interface UpdateSourceReqData {
  /** 情报源类型,可选值：hawk_eye=鹰眼威胁情报 */
  source_type: string
  /** AppKey */
  app_key?: string
  /** Secret */
  secret?: string
  /** 状态 1=启动，2=禁用 */
  status?: number
  /** 循环类型：1-每天；2-每周；3-每月 */
  frequency?: number
  /** 当天开始更新时间 */
  start_minutes?: string[]
  /** 定时更新状态 1=启动，2=禁用 */
  timing_update_status?: string|number
}

export interface UpdateSourceReq {
  data?: UpdateSourceReqData
}

export interface OnlineUpdateReq {
  /** 情报源类型,可选值：hawk_eye=鹰眼威胁情报 */
  source_type?: string
}

export interface OnlineUpdateRes {
  /** 任务id */
  task_id?: string
}
export interface SubmitVirusRequestParams {
  /** app_key 预留非必填 */
  app_key?: string
  /** 循环类型：1-每天；2-每3天；3-每周；4-每月 */
  frequency?: number
  /** id */
  id?: string
  /** app_secret 预留非必填 */
  secret?: string
  /** source_type 病毒库来源 默认值：file5 */
  source_type?: string
  /** 开始时间 */
  start_minutes?: (string|number)[]|string
  /** 定时更新状态 1=启动，2=禁用 */
  timing_update_status?: number
}
export interface VirusLogRequestParams {
  date?: (string|number|null)[]
  /** 结束时间 */
  end_time?: string | null
  /** 第几页 */
  page_no?: number
  /** 每页条数 */
  page_size?: number
  /** 开始时间 */
  start_time?: string | null
  /** 更新状态 1=更新成功，2=更新失败，3=更新中 */
  status?: number
  /** 更新类型，0-全部 1=手动在线更新，2=定时在线更新，3=离线手动 */
  update_type?: number
}
export interface VirusLogData {
  source_type: string
  /** 更新类型，1=手动在线更新，2=定时在线更新，3=离线手动 */
  update_type: number
  /** 更新状态 1=更新成功，2=更新失败，3=更新中 */
  status: number
  /** 任务描述 */
  description: string
  /** 任务创建时间 */
  create_time: string
  /** 执行时间 */
  execution_time: string
  /** 操作人id */
  uid: string
}
export interface VirusLogResponseData {
  data?: VirusLogData[]
  total?: number
}

export interface VirusUpdateData {
  /** 状态,1=更新成功，2=更新失败，3=更新中 */
  status: number
  /** 任务描述 */
  description?: string
}
export interface VirusStatus {
  task_id?: string
}
export interface UpdateState {
  /** 1=需要更新，2=不需要更新 */
  state?: number
}
export interface NetResponseData {
  /** 网络状态：1-无法连接外网，2-网络正常，3-网络不稳定，4-能连外网但连不了后台/下载地址 */
  status: number
}
@Injectable()
export class CloudFeatureOffLineLibraryService {
  constructor (private http: Http) {
  }
  // 获取病毒细腻些
  getVirusDatabaseInfo (data: VirusDatabaseInfo) {
    return this.http.post<VirusDatabaseInfoData>('/sample/update/virus_database_info', data)
  }
  // 更新病毒库配置
  updateVirusConfigSource (data: SubmitVirusRequestParams) {
    return this.http.post<void>('/sample/virus_database/add_or_update', {source_type:'file5',...data})
  }
  // 病毒库日志
  @ParamsClean()
  getSampleUpdateTaskListLog (data: VirusLogRequestParams) {
    const parseData = parseIsNotEmptyObj(data)
    return this.http.post<VirusLogResponseData>('/sample/update/task_list', parseData)
  }
  // 查看病毒库更新任务结果
  getSampleUpdateOfflineVirusStatus (task_id: VirusStatus) {
    return this.http.post<VirusUpdateData>('/sample/update/offline_virus_status', {task_id})
  }
  //是否需要更新
  getSampleUpdateUpdateState () {
    return this.http.post<UpdateState>('/sample/update/update_state', {})
  }
  // 手动在线更新
  getSampleUpdateOnlineUpdate () {
    return this.http.post<VirusStatus>('/sample/update/online_update', {})
  }
  // 在线更新前检查网络问题
   getApiPrivatizationauthNetCheck () {
    return this.http.post<NetResponseData>('/privatizationauth/net_check', {})
  }
}
